// extracted by mini-css-extract-plugin
module.exports = {"formTitleContainer":"Amenities_formTitleContainer__1F1CZ","formItemContainer":"Amenities_formItemContainer__19KUv","formItem":"Amenities_formItem__aE2gA"};